var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height"},[_c('TabBasic',{ref:"tabBasic",attrs:{"items":_vm.tabs,"show-breadcrumbs":""},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('v-spacer')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }